import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlined from "@material-ui/icons/LockOutlined";
import MailOutline from "@material-ui/icons/MailOutline";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import VpnKey from "@material-ui/icons/VpnKey";
import AuthApi from "../../../Services/Authapi";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import "./Forgotpassword.css";
import { Link } from "react-router-dom";
import { getLoginContentSettings } from "../../../../utils/loginContentSettings";
import { createSwalLoaderNode } from "../../swalLoader";

const validationSchema = yup.object({
    email: yup
        .string()
        .email("Enter a valid email")
        .required("Email is required"),
    otp: yup
        .string()
        .when('otpVisible', {
            is: true,
            then: yup.string().required("OTP is required")
        }),
    password: yup
        .string()
        .when('passwordVisible', {
            is: true,
            then: yup.string().min(8, "Password should be of minimum 8 characters length").required("Password is required")
        }),
    password_confirmation: yup
        .string()
        .when('passwordVisible', {
            is: true,
            then: yup.string().min(8, "Password should be of minimum 8 characters length").required("Password is required")
        }),
});

const Forgotpassword = (props) => {
    const history = useHistory();
    const [otpVisible, setOtpVisible] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);
    const [loginContent, setLoginContent] = useState(() => getLoginContentSettings());

    React.useEffect(() => {
        AuthApi.getLoginContent()
            .then((response) => {
                if (response && response.status && response.data) {
                    setLoginContent({
                        title: response.data.title || "",
                        title2: response.data.title2 || "",
                        quotes: response.data.quotes || "",
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching login content:", error);
            });
    }, []);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleClickShowPassword1 = () => {
        setShowPassword1(!showPassword1);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseDownPassword1 = (event) => {
        event.preventDefault();
    };

    const formik = useFormik({
        initialValues: {
            email: "",
            otp: "",
            password: "",
            password_confirmation: "",
            otpVisible: false,
            passwordVisible: false,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            if (!otpVisible) {
                swal({
                    title: "Loading",
                    text: "Please wait...",
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    width: "10%",
                    content: createSwalLoaderNode()
                });

                const response = await AuthApi.gmailotp({ email: values.email });
                if (response.status === true) {
                    swal("Success", "OTP sent to your email!", "success");
                    setOtpVisible(true);
                    formik.setFieldValue('otpVisible', true);
                } else {
                    swal("Error", response.message, "error");
                }

            } else if (!passwordVisible) {

                const response = await AuthApi.verifyotp({ email: values.email, otp: values.otp });
                if (response.status === true) {
                    swal("Success", "OTP verified successfully!", "success");
                    setPasswordVisible(true);
                    formik.setFieldValue('passwordVisible', true);
                } else {
                    swal("Error", response.message || "Invalid OTP. Please try again.", "error");
                }

            } else {

                const response = await AuthApi.resetpassword({ email: values.email, otp: values.otp, password: values.password, password_confirmation: values.password_confirmation });
                if (response.status === true) {
                    swal("Success", "Password reset successfully!", "success");
                    history.push("/login");
                } else {
                    swal("Error", response.message || "Failed to reset password. Please try again.", "error");
                }

            }
        },
    });

    return (
        <main className="hrms-forgot-page">
            <section className="hrms-forgot-card">
                <div className="hrms-forgot-visual">
                    <div className="hrms-forgot-visual__content">
                        <h2>{loginContent.title}</h2>
                        <p>{loginContent.title2}</p>
                        {loginContent.quotes && (
                            <p className="hrms-forgot-visual__quote">{loginContent.quotes}</p>
                        )}
                    </div>

                    <span className="hrms-forgot-shape hrms-forgot-shape--circle" aria-hidden="true" />
                    <span className="hrms-forgot-shape hrms-forgot-shape--bar-one" aria-hidden="true" />
                    <span className="hrms-forgot-shape hrms-forgot-shape--bar-two" aria-hidden="true" />
                    <span className="hrms-forgot-shape hrms-forgot-shape--bar-three" aria-hidden="true" />
                    <span className="hrms-forgot-shape hrms-forgot-shape--bar-four" aria-hidden="true" />

                    <span className="hrms-forgot-line hrms-forgot-line--one" aria-hidden="true" />
                    <span className="hrms-forgot-line hrms-forgot-line--two" aria-hidden="true" />
                    <span className="hrms-forgot-line hrms-forgot-line--three" aria-hidden="true" />
                    <span className="hrms-forgot-line hrms-forgot-line--four" aria-hidden="true" />
                </div>

                <div className="hrms-forgot-panel">
                    <div className="hrms-forgot-panel__inner">
                        <h1 className="hrms-forgot-panel__title">
                            {passwordVisible ? "RESET PASSWORD" : otpVisible ? "VERIFY OTP" : "FORGOT PASSWORD"}
                        </h1>

                        <form className="hrms-forgot-form" onSubmit={formik.handleSubmit}>
                            {!passwordVisible && (
                                <TextField
                                    fullWidth
                                    id="email"
                                    name="email"
                                    placeholder="Email"
                                    variant="outlined"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                    className="hrms-forgot-form__field"
                                    autoComplete="email"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MailOutline />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}

                            {!passwordVisible && otpVisible && (
                                <TextField
                                    fullWidth
                                    id="otp"
                                    name="otp"
                                    placeholder="OTP"
                                    variant="outlined"
                                    value={formik.values.otp}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.otp && Boolean(formik.errors.otp)}
                                    helperText={formik.touched.otp && formik.errors.otp}
                                    className="hrms-forgot-form__field"
                                    autoComplete="one-time-code"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <VpnKey />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}

                            {passwordVisible && (
                                <>
                                    <TextField
                                        fullWidth
                                        id="password"
                                        name="password"
                                        placeholder="New Password"
                                        type={showPassword ? "text" : "password"}
                                        variant="outlined"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.password && Boolean(formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                        className="hrms-forgot-form__field"
                                        autoComplete="new-password"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <LockOutlined />
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        className="hrms-forgot-form__visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />

                                    <TextField
                                        fullWidth
                                        id="password_confirmation"
                                        name="password_confirmation"
                                        placeholder="Confirm Password"
                                        type={showPassword1 ? "text" : "password"}
                                        variant="outlined"
                                        value={formik.values.password_confirmation}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.password_confirmation && Boolean(formik.errors.password_confirmation)}
                                        helperText={formik.touched.password_confirmation && formik.errors.password_confirmation}
                                        className="hrms-forgot-form__field"
                                        autoComplete="new-password"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <LockOutlined />
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        className="hrms-forgot-form__visibility"
                                                        onClick={handleClickShowPassword1}
                                                        onMouseDown={handleMouseDownPassword1}
                                                        edge="end"
                                                    >
                                                        {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </>
                            )}

                            <Button
                                className="hrms-forgot-form__submit"
                                color="primary"
                                variant="contained"
                                type="submit"
                            >
                                {passwordVisible ? "RESET PASSWORD" : otpVisible ? "VERIFY OTP" : "SEND OTP"}
                            </Button>

                            <Link className="hrms-forgot-form__login" to="/login">
                                Login
                            </Link>
                        </form>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Forgotpassword;
